<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 质控课程</div>
        <div class="title-nav">
          <div class="nav-li" v-for="(item, index) in navItems" :key="index" :class="{ active: activeIndex === item.id }" @click="setActive(item)">
            {{ item.name }}
          </div>
        </div>
        <template v-if="isChildren">
          <courseTwo v-if="courses.length > 0" :courses="courses"/>
          <empty class="empty-margin" v-if="courses.length <= 0"></empty>
        </template>
        <template v-if="!isChildren">
          <course v-if="courses.length > 0" :courses="courses" :watchedList="watchedList" />
          <empty class="empty-margin" v-if="courses.length <= 0"></empty>
        </template>
        <el-pagination class="paging" background :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="prev, pager, next, sizes" :total="totalCount" @size-change="sizeChange"
          @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
        </el-pagination>
      </div>
    </div>
    <!---->

    <footer-bar @showPrivacyPolicy="dialogFormVisible3 = true" @showUserAgreement="dialogFormVisible4 = true"></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import course from "@/components/base/course";
import courseTwo from "@/components/base/courseTwo";
import { getPageList, getInformationType, getPageListTwo } from '@/api/home'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, course, empty, courseTwo },
  data() {
    return {
      selectedIndex: 1,
      courses: [],
      watchedList: [], // 示例已观看的课程 ID
      navItems: [], // 导航项
      activeIndex: '', // 默认激活第一个项
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      searchTitle: '',
      isChildren: false,
    }
  },
  watch: {
    "$route" (to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.currentPage = 1
      this.getPageList()
    },
  },
  methods: {
    setActive(value) {
      this.courses = []
      this.activeIndex = value.id; // 设置当前激活的项
      this.isChildren = value.isChildren
      if(this.isChildren) {
        this.getPageListTwo()
      }else {
        this.getPageList()
      }
    },
    // 列表查询资讯类型
    async getInformationType() {
      await getInformationType({
        categories: 'COURSE',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
        this.isChildren = res.data.length > 0 ? res.data[0].isChildren : false
      })
    },
    // 分页查询新闻资讯、质控课程、质控公告
    async getPageList() {
      await getPageList({
        number: this.currentPage,
        limit: this.pageSize,
        checkStatus: 'HAVE_RELEASED',
        categories: 'COURSE',
        type: this.activeIndex,
        title: this.searchTitle,
      }).then(res => {
        this.courses = res.data
        this.totalCount = res.totalCount
      })
    },
    // 多级分类课程
    async getPageListTwo() {
      await getPageListTwo({
        number: this.currentPage,
        limit: this.pageSize,
        typeId: this.activeIndex,
      }).then(res => {
        this.courses = res.data
        this.totalCount = res.totalCount
      })
    },
    // 初始化
    async Initialization() {
      await this.getInformationType()
      if(this.isChildren) {
        await this.getPageListTwo()
      }else {
        await this.getPageList()
      }
    },
    sizeChange(value) {
      this.pageSize = value
      this.currentPage = 1
      if(this.isChildren) {
        this.getPageListTwo()
      }else {
        this.getPageList()
      }
    },
    currentChange(value) {
      this.currentPage = value
      if(this.isChildren) {
        this.getPageListTwo()
      }else {
        this.getPageList()
      }
    },
    prevClick(value) {
      this.currentPage = value
      if(this.isChildren) {
        this.getPageListTwo()
      }else {
        this.getPageList()
      }
    },
    nextClick(value) {
      this.currentPage = value
      if(this.isChildren) {
        this.getPageListTwo()
      }else {
        this.getPageList()
      }
    },
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    wow.init();
    this.Initialization()
  }
}
</script>

<style lang="less" scoped>
/deep/.qualityControl-box .course-li {
  margin-top: 26px;
}

.center-box {
  padding-bottom: 80px;
}

/deep/.el-input__inner {
  // height: 32px;
  // border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  // color: rgba(0, 0, 0, 0.45) !important;
  // line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/course/index.vue